import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';

import AppSACICT from '@/views/AppSACICT.vue';

import usePermission from '@/usePermission';

import Login from '../views/Login.vue';
import Logout from '../views/Logout.vue';

import Dashboard from '../views/Dashboard.vue';
import LearningIndex from '../views/LearningCenter/Index.vue';
import LearningList from '../views/LearningCenter/List.vue';
import LearningCenterEditor from '../views/LearningCenter/LearningCenterEditor.vue';

import CreatorIndex from '../views/Creator/Index.vue';
import CreatorList from '../views/Creator/List.vue';
import CreatorEditor from '../views/Creator/CreatorEditor.vue';

import HandicraftList from '../views/Handicraft/List.vue';
import HandicraftEditor from '../views/Handicraft/HandicraftEditor.vue';

import MediaList from '../views/Media/List.vue';
import MediaEditor from '../views/Media/MediaEditor.vue';

import KnowledgeList from '../views/Knowledge/List.vue';
import KnowledgeEditor from '../views/Knowledge/KnowledgeEditor.vue';

import LogIndex from '../views/Log/Index.vue';

import UserList from '../views/User/List.vue';
import UserEditor from '../views/User/UserEditor.vue';

import Setting from '../views/Setting/Setting.vue';

Vue.use(VueRouter);

const guardAuth = async (to: Route, from: Route, next: (route?: any) => void) => {
  if (localStorage.getItem('apollo-token')) {
    next(); // TODO: implement token expire check
  } else {
    next({ name: 'Login' });
  }
};

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/app',
    beforeEnter: guardAuth, // Check only root, no need to check children
    component: AppSACICT,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'handicraft',
        component: CreatorIndex,
        children: [
          {
            path: '',
            name: 'Handicraft',
            component: HandicraftList,
          },
          {
            path: 'create',
            name: 'HandicraftCreate',
            component: HandicraftEditor,
            meta: { mode: 'create' },
          },
          {
            path: 'edit/:handicraftId',
            name: 'HandicraftEdit',
            component: HandicraftEditor,
            meta: { mode: 'edit' },
          },
          {
            path: ':handicraftId',
            name: 'HandicraftView',
            component: HandicraftEditor,
            meta: { mode: 'view' },
          },
        ],
      },
      {
        path: 'learning',
        component: LearningIndex,
        children: [
          {
            path: '',
            name: 'Learning',
            component: LearningList,
          },
          {
            path: 'create',
            name: 'LearningCenterCreate',
            component: LearningCenterEditor,
            meta: { mode: 'create' },
          },
          {
            path: 'edit/:learningCenterId',
            name: 'LearningCenterEdit',
            component: LearningCenterEditor,
            meta: { mode: 'edit' },
          },
          {
            path: ':learningCenterId',
            name: 'LearningCenterView',
            component: LearningCenterEditor,
            meta: { mode: 'view' },
          },
        ],
      },
      {
        path: 'creator',
        component: CreatorIndex,
        children: [
          {
            path: '',
            name: 'Creator',
            component: CreatorList,
          },
          {
            path: 'create',
            name: 'CreatorCreate',
            component: CreatorEditor,
            meta: { mode: 'create' },
          },
          {
            path: 'edit/:creatorId',
            name: 'CreatorEdit',
            component: CreatorEditor,
            meta: { mode: 'edit' },
          },
          {
            path: ':creatorId',
            name: 'CreatorView',
            component: CreatorEditor,
            meta: { mode: 'view' },
          },
        ],
      },
      {
        path: 'media',
        component: CreatorIndex,
        children: [
          {
            path: '',
            name: 'Media',
            component: MediaList,
          },
          {
            path: 'create',
            name: 'MediaCreate',
            component: MediaEditor,
            meta: { mode: 'create' },
          },
          {
            path: 'edit/:mediaId',
            name: 'MediaEdit',
            component: MediaEditor,
            meta: { mode: 'edit' },
          },
          {
            path: ':mediaId',
            name: 'MediaView',
            component: MediaEditor,
            meta: { mode: 'view' },
          },
        ],
      },
      {
        path: 'knowledge',
        component: CreatorIndex,
        children: [
          {
            path: '',
            name: 'Knowledge',
            component: KnowledgeList,
          },
          {
            path: ':handicraftTypeId',
            name: 'KnowledgeList',
            component: KnowledgeList,
          },
          {
            path: ':handicraftTypeId/create',
            name: 'KnowledgeCreate',
            component: KnowledgeEditor,
            meta: { mode: 'create' },
          },
          {
            path: 'edit/:knowledgeId',
            name: 'KnowledgeEdit',
            component: KnowledgeEditor,
            meta: { mode: 'edit' },
          },
          {
            path: ':handicraftTypeId/:knowledgeId',
            name: 'KnowledgeView',
            component: KnowledgeEditor,
            meta: { mode: 'view' },
          },
        ],
      },
      {
        path: 'log',
        component: LogIndex,
        name: 'Log',
      },
      {
        path: 'user',
        component: CreatorIndex,
        children: [
          {
            path: '',
            name: 'User',
            component: UserList,
          },
          {
            path: ':roleId',
            name: 'UserList',
            component: UserList,
          },
          {
            path: 'create',
            name: 'UserCreate',
            component: UserEditor,
            meta: { mode: 'create' },
          },
          {
            path: 'edit/:userId',
            name: 'UserEdit',
            component: UserEditor,
            meta: { mode: 'edit' },
          },
          {
            path: 'view/:userId',
            name: 'UserView',
            component: UserEditor,
            meta: { mode: 'view' },
          },
        ],
      },
      {
        path: 'setting',
        component: Setting,
        name: 'Setting',
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
